export const getStatusIcon = (status) => {
  const normalizedStatus = status ? status.toLowerCase() : 'unexplored';
  switch (normalizedStatus) {
    case 'mastered':
      return { icon: 'check_circle', color: 'text-green-500' };
    case 'needs_improvement':
      return { icon: 'trending_up', color: 'text-amber-500' };
    case 'in_progress':
      return { icon: 'hourglass_top', color: 'text-blue-500' };
    case 'unexplored':
    default:
      return { icon: 'radio_button_unchecked', color: 'text-slate-400' };
  }
};